import { put } from 'redux-saga/effects';
import { collectionSetInStoreAction } from 'common/actions/collection';
import { errorHandleAction } from 'components/error-handle/actions';
import { myVideosFetchApi } from 'common/api/users';
import { collectionIsLoadingAction } from 'common/actions';

export function* myVideosRequestEffect(action) {
  try {
    yield put(collectionIsLoadingAction());
    const { pageNum, sorting, perPage, userId } = action.payload;
    const collection = yield myVideosFetchApi({ pageNum, sorting, perPage, userId });
    yield put(collectionSetInStoreAction(collection));
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}

export function* myVideosRequestMobileEffect({ payload }) {
  try {
    yield put(collectionIsLoadingAction());
    const { sorting, perPage, userId, prevVideos } = payload;

    let { pageNum } = payload;
    pageNum = ++pageNum;

    const collection = yield myVideosFetchApi({ pageNum, sorting, perPage, userId });
    if (pageNum > 1) {
      collection.videos = [].concat(prevVideos, collection.videos);
      collection.pageNum = pageNum;
    }
    yield put(collectionSetInStoreAction(collection));
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}
